/**
 * Chrome-only polarity hints for KPI trend deltas (no business logic).
 * Metrics listed here treat an upward delta as worse (danger/warn chrome)
 * and a downward delta as better — invert vs default “up = success”.
 *
 * Keys are i18n / metric id strings callers already use for labels.
 * Wire into KpiCard `direction`/`tone` mapping at the call site only.
 *
 * @see KpiCard — delta chrome uses `direction` up/down/flat.
 */
export const KPI_TREND_WORSE_WHEN_UP = [
  'inventory.kpi.low',
  'inventory.kpi.oos',
  'refunds',
  'incidents',
] as const;

export type KpiTrendWorseWhenUpId = (typeof KPI_TREND_WORSE_WHEN_UP)[number];

const WORSE_WHEN_UP = new Set<string>(KPI_TREND_WORSE_WHEN_UP);

/** True when an increasing value is undesirable for chrome polarity. */
export function isKpiTrendWorseWhenUp(metricId: string): boolean {
  return WORSE_WHEN_UP.has(metricId);
}
